import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Manifesto from "@/components/Manifesto";
import Comparison from "@/components/Comparison";

const EASE = [0.16, 1, 0.3, 1];

function CatalogTeaser() {
  return (
    <section data-testid="home-catalog-teaser" className="border-y border-zinc-200 bg-tour-zinc/60 py-20 sm:py-24">
      <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-8 px-5 sm:px-8 md:flex-row md:items-center">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, ease: EASE }}
          className="max-w-2xl"
        >
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.25em] text-zinc-500">The catalog</p>
          <h2 className="font-display text-2xl font-extrabold tracking-tighter sm:text-3xl">
            Tees, hoodies, headwear, posters — <span className="font-serif italic font-medium">no listed prices,</span> all quoted to your routing.
          </h2>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: 0.12, ease: EASE }}
        >
          <Link
            data-testid="home-catalog-link"
            to="/catalog"
            className="group flex items-center gap-2 bg-tour-void px-7 py-4 font-mono text-xs uppercase tracking-widest text-white transition-colors hover:bg-tour-red"
          >
            Browse the catalog
            <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
          </Link>
        </motion.div>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Manifesto />
      <CatalogTeaser />
      <Comparison />
    </>
  );
}
